import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Card,
  title: 'Card',
  category: ComponentCategory.Layout,
};
